import request from '@/config/axios'

export interface LiveCommentVO {
  id?: number
  liveId?: number
  userId?: number
  content?: string
  status?: number
  createTime?: string
}

export const pageComment = (params: any) => request.get({ url: '/live/comment/page', params })
export const updateCommentStatus = (id: number, status: number) =>
  request.post({ url: '/live/comment/update-status', params: { id, status } })
export const deleteComment = (id: number) =>
  request.delete({ url: '/live/comment/delete', params: { id } })
